import axios, { type InternalAxiosRequestConfig } from "axios";
import { runTimeConfig } from "@/config";
import { refreshSession } from "./authRefresh";
import { authService } from "./authServiceInstance";

export const axiosInstance = axios.create({
  baseURL: runTimeConfig?.VITE_BASE_URL ?? ""
});
export const cancelAxios = axios.CancelToken;

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    const token = authService.getToken();
    if (token != null && config.headers != null) {
      // Use .set if available (Axios v1), otherwise plain object assignment
      if (typeof config.headers.set === "function") {
        config.headers.set("Authorization", `Bearer ${token}`);
      } else {
        (config.headers as any).Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  async function (error: any) {
    return await Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error: unknown) {
    if (!axios.isAxiosError(error)) {
      return await Promise.reject(error);
    }

    const originalRequest = error.config as
      | (InternalAxiosRequestConfig & { _retry?: boolean })
      | undefined;

    // If the error is 401 and we haven't retried yet
    if (
      error.response?.status === 401 &&
      originalRequest !== undefined &&
      originalRequest._retry !== true
    ) {
      originalRequest._retry = true;

      try {
        // Attempt to refresh the session
        // Multiple simultaneous requests will wait for the same refresh promise
        await refreshSession();

        // Re-run the original request.
        // The request interceptor above will automatically inject the NEW token
        // since we are using the same axiosInstance.
        return await axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Global Session Refresh Failed:", refreshError);
        // If refresh fails, sign out
        authService?.signoutRedirectCallback();
        return await Promise.reject(refreshError);
      }
    }

    console.log("api response Error", error);
    return await Promise.reject(error);
  }
);

// import axios from 'axios';
// import { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
// import AuthService from './authService';

// const axiosInstance = axios.create()
// const cancelAxios = axios.CancelToken

// const AxiosInterceptor = ({ children }: any) => {

//     const navigate = useNavigate();
//     const authService = new AuthService();
//     let requestArray: any = []

//     useEffect(() => {

//         const resInterceptor = async (response: any) => {
//             return await response;
//         }

//         const errInterceptor = async (error: any) => {
//             const originalRequest = error.config;
//             requestArray.push(originalRequest)
//             return Promise.reject(error);
//         }

//         const interceptor = axiosInstance.interceptors.response.use(resInterceptor, errInterceptor);

//         return () => axiosInstance.interceptors.response.eject(interceptor);

//     }, [navigate])

//     return children;
// }

// export { cancelAxios, axiosInstance };
// export { AxiosInterceptor }
